// WebComponent
if (!customElements.get('cross-sell-swiper')) {
    class CrossSellSwiper extends HTMLElement {
        constructor() {
            super();
            this.swiper = null;
            this.swiperContainer = this.querySelector('.cross-sell-swiper-swiper');
            // this.prevBtn = this.querySelector('.swiper-button-prev');
            // this.nextBtn = this.querySelector('.swiper-button-next');
            this.pagination = this.querySelector('.swiper-pagination');
            this.blockSize = this.swiperContainer.dataset.size;
        }

        connectedCallback() {
            this.initSwiper();
            this.selectColor();
        }

        selectColor() {
            const slide = this.querySelectorAll('.cross-sell-swiper-slide');
            //每个slide监听点击事件，使用事件委托，监听slide下的.cross-sell-swiper-slide__product-info__colors下的所有.cross-sell-swiper-slide__product-info__color-button的点击事件
            slide.forEach((item) => {
                item.addEventListener('click', (e) => {
                    if (e.target.classList.contains('cross-sell-swiper-slide__product-info__color-button')) {
                        // 记录当前颜色的data-variant-id和data-product-id
                        const variantId = e.target.dataset.variantId;
                        const productId = e.target.dataset.productId;

                        console.log("选择的变体id:", variantId);

                        // 移除所有颜色按钮的选中状态
                        item.querySelectorAll('.cross-sell-swiper-slide__product-info__color-button').forEach((btn) => {
                            btn.classList.remove('active');
                        });
                        // 添加当前点击按钮的选中状态
                        e.target.classList.add('active');

                        // 颜色主图
                        item.querySelectorAll('.cross-sell-swiper-slide-variant-image').forEach((img) => {
                            img.classList.remove('active');
                        });
                        // 找到.cross-sell-swiper-slide-variant-image的data-variant-id和当前点击按钮的data-variant-id相同的元素，添加active类
                        item.querySelectorAll('.cross-sell-swiper-slide-variant-image').forEach((img) => {
                            if (img.dataset.variantId === variantId) {
                                img.classList.add('active');
                            }
                        });

                        // 获取产品信息
                        // const productInfo = item.querySelector('.cross-sell-swiper-slide__product-info');
                        // // 解析产品信息
                        // const productInfoData = JSON.parse(productInfo.textContent);
                        // console.log(productInfoData);

                        // 更新表单的变体id
                        const addToCartBtn = item.querySelector('.product-form input[name=id]');
                        addToCartBtn.value = variantId;
                    }
                });
            });

        }

        initSwiper() {
            if (this.swiperContainer) {
                this.swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 3,
                    spaceBetween: 33,
                    // navigation: {
                    //     nextEl: this.nextBtn,
                    //     prevEl: this.prevBtn,
                    // },
                    autoHeight: true,
                    centerInsufficientSlides: true,
                    pagination: {
                        el: this.pagination,
                        clickable: true,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 30,
                        },
                        1000: {
                            slidesPerView: 3,
                            spaceBetween: 33,
                        },
                    }
                });
            }
        }
    }
    customElements.define('cross-sell-swiper', CrossSellSwiper);
}